import React from 'react';

const DataTableContainer = ({ children }) => {
  return (
    <div className="">
      {children}
    </div>
  );
};

export default DataTableContainer;